import { render, staticRenderFns } from "./file-container-card.vue?vue&type=template&id=0318513f&scoped=true&"
import script from "./file-container-card.vue?vue&type=script&lang=js&"
export * from "./file-container-card.vue?vue&type=script&lang=js&"
import style0 from "./file-container-card.vue?vue&type=style&index=0&id=0318513f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0318513f",
  null
  
)

export default component.exports